module.exports = __webpack_public_path__ + "static/media/Study_Icon.875435ef.svg";